// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Design/components/WoodConnectionDesign/styles.scss
// module id = 1279
// module chunks = 0